import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttempts } from './components/FailedAttempts';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForNotFor } from './components/ForNotFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { OfferBlock } from './components/OfferBlock';
import { BonusTransition } from './components/BonusTransition';
import { BonusSection } from './components/BonusSection';
import { BonusClosing } from './components/BonusClosing';
import { ValueSummary } from './components/ValueSummary';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SectionSeparator } from './components/SectionSeparator';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-navy text-slate-100 font-sans overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SectionSeparator data-id="element-4" />
      <FailedAttempts data-id="element-5" />
      <Mechanism data-id="element-6" />
      <SectionSeparator data-id="element-7" />
      <WhatYouGet data-id="element-8" />
      <ForNotFor data-id="element-9" />
      <HowItWorks data-id="element-10" />
      <SectionSeparator data-id="element-11" />
      <Proof data-id="element-12" />
      <FAQ data-id="element-13" />
      <OfferBlock data-id="element-14" />
      <SectionSeparator data-id="element-15" />
      <BonusTransition data-id="element-16" />
      <BonusSection data-id="element-17" />
      <BonusClosing data-id="element-18" />
      <ValueSummary data-id="element-19" />
      <FinalCTA data-id="element-20" />
      <Footer data-id="element-21" />
    </div>;
}